const NotFound = () => {
  return <div className="flex items-center justify-center text-display2Xl text-white h-screen">Teamfit (company required)</div>;
};

export default NotFound;
